var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0554 11.2633C16.2483 11.114 16.4045 10.9226 16.5119 10.7036C16.6193 10.4846 16.6752 10.2439 16.6752 9.99999C16.6752 9.75608 16.6193 9.5154 16.5119 9.29641C16.4045 9.07743 16.2483 8.88595 16.0554 8.73666C13.5575 6.80385 10.7683 5.2804 7.79209 4.22333L7.24792 4.02999C6.20792 3.66083 5.10875 4.36416 4.96792 5.43833C4.57449 8.46671 4.57449 11.5333 4.96792 14.5617C5.10959 15.6358 6.20792 16.3392 7.24792 15.97L7.79209 15.7767C10.7683 14.7196 13.5575 13.1961 16.0554 11.2633Z",
    fill: "white",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.1a9b092cb148cab591ece9926875623f.svg";
export { ForwardRef as ReactComponent };